<div class="modal-body">
    <div class="row">
        <div class="col-md-12 col-sm-12 col-12  m-0 sign-in">
            <form action="#" class="p-5 bg-white box-effect" [formGroup]="loginForm" #myForm="ngForm"
                action="" method="post"><!--onLogin() (ngSubmit)="executeImportantAction()" -->

                <h1 class="lead mb-md-3 login-heading">Sign In to JBI</h1>
                <div class="alert alert-danger" *ngIf="error && !loginSuccess" style="padding:2px;">
                    <p style="margin-top:10px">{{error}}</p>
                </div>

                <div class="alert alert-success" *ngIf="success && loginSuccess" style="padding:2px;">
                    <p>{{success}}</p>
                </div>
                <div class="row form-group">
                    <div class="col-md-12 mb-3 mb-md-3 m-0">
                        <label class="lbl_login" for="fullname">Username/Email</label>
                        <input type="text" id="fullname" name="email" class="form-control input-login"
                            placeholder="username/email" formControlName="email"
                            [ngClass]="{ 'is-invalid': submitted && formfields.email.errors }" />

                           

                        <span class="invalid-feedback" *ngIf="formfields.email.errors?.['required']">
                            <!-- Error message content -->
                            Email/Username is mandatory
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-md-12 mb-md-3">
                        <label class="lbl_login" for="pwd">Password</label>
                             <div class="input-group">
                                <input [type]="showNewPassword ? 'text' : 'password'" id="password" formControlName="password" class="form-control">
                                <div class="input-group-append">
                                  <span class="input-group-text" id="newPasswordEye" (click)="togglePasswordVisibility('password')">
                                    <fa-icon [icon]="['fas','eye']"></fa-icon>
                                  </span>
                                </div>
                              </div>
                        <span class="invalid-feedback" *ngIf="formfields.password.errors?.['required']">
                            Password is mandatory
                        </span>
                    </div>
                </div>

                <!--recaptcha-->

                 <!-- <div class="row form-group">
                    <div class="col-md-12 mb-md-3">
                        <div class="wrap-input validate-input uname-div">
                            <input type="hidden" formControlName="recaptcha">
                            <ngx-recaptcha2 #captchaElem [siteKey]="siteKey" (reset)="handleReset()"
                                (expire)="handleExpire()" (load)="handleLoad()" (success)="handleSuccess($event)"
                                [useGlobalDomain]="false" formControlName="recaptcha">
                            </ngx-recaptcha2>
                        </div>
                        <span class="invalid-feedback-captcha"
                            *ngIf="loginForm.controls.recaptcha.errors?.['required']">
                            Please complete the reCAPTCHA.
                        </span>
                        
                    </div>
                </div> -->


                <div class="row form-group">
                    <div class="col-md-12 col-sm-12 loginbtn">

                        <button *ngIf="!loginSuccess" type="submit" class="btn btn-primary btn-signin" (click)="executeImportantAction()">Sign In</button>

                        <button  *ngIf="loginSuccess" class="buttonload btn btn-primary btn-signin">
                            <i class="fa fa-spinner fa-spin"></i>
                        </button>
                    </div>

                    <div class="col-md-12 col-sm-12 forgotbtn" (click)="moveToResetPassword()">
                        <a class="btn btn-default" title="Forgot password"> Forgot password? </a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>